import * as React from "react";
import {Block, Editor, Point} from "slate";


export class FieldPickerTextBoxSlateRenderer extends React.Component<FieldPickerSlateRendererProps, FieldPickerSlateRendererState> {
    static defaultProps: Partial<FieldPickerSlateRendererProps> = {};

    constructor(props: FieldPickerSlateRendererProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <span contentEditable={false} style={{display:'inline-block',verticalAlign:'text-bottom'}} className={'SlateField '+(this.props.SlateProps.isSelected?'rnFieldSelected':'')}
                  onClick={(e)=>{e.preventDefault();e.stopPropagation();this.Select()}} >
                    {this.GetFormattedLabel()}
                <span style={{display:'none'}}>
                        {this.props.SlateProps.children}
                    </span>
            </span>
        )
    }

    public GetFormattedLabel(){
        switch (this.props.Node.data.get('SubType')) {
            case 'fixed':
          //      return ServerFixedFieldDictionary.find(x=>x.Id==this.props.Node.data.get('FieldId')).Label;
            case 'field':
                let value=this.props.Node.data.get('FieldId');
                let field=this.props.Model.find(x=>x.Id==value);
                return field.Id+": "+field.Label;

        }

    }


    public Select(){
        this.props.Editor.select({anchor:Point.create({key:this.props.Node.key,offset:0}),focus:Point.create({key:this.props.Node.key,offset:0})});

    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldPickerSlateRendererProps {
    Node:Block;
    Editor:Editor;
    SlateProps:any;
    Model:FieldDTO[];
}

interface FieldPickerSlateRendererState {

}

//#endregion "My Region"